import {Component, Input} from '@angular/core';
import {OnDestroyMixin} from '@w11k/ngx-componentdestroyed';
import {Service} from '../../home/home.interface';
import {ContactPerson} from '../contact-card-view/contact-persons.interface';

@Component({
  selector: 'dwg-find-contact',
  templateUrl: './find-contact.component.html',
  styleUrls: ['./find-contact.component.scss']
})

export class FindContactComponent extends OnDestroyMixin {
  @Input() heading: string;
  @Input() serviceBoxItems: Service[] = [];
  @Input() allContactPersons: ContactPerson[] = [];
  filteredContactPersons: ContactPerson[];
  // readonly districts = districts;

  constructor() {
    super();
  }

  selectedService: Service = null;
  // selectedDistrict: string = null;

  onServiceLinkClick(event, service: Service) {
    event.preventDefault();
    event.stopPropagation();
    this.selectedService = service;

    this.filteredContactPersons = this.allContactPersons.filter(cp => (cp[service.label]))
  }

  onServiceClose() {
    this.selectedService = null;
    // this.selectedDistrict = null;
  }

  // onDistrictSelect(value) {
  //   this.selectedDistrict = value;
  //   this.store.select(selectConfigState).pipe(
  //     take(1),
  //     untilComponentDestroyed(this)
  //   ).subscribe(configData => {
  //     this.filteredContactPerson = configData.data.contactPersons
  //       .filter(person => person[this.selectedService.label])
  //       .filter(person => person[this.selectedDistrict])[0];
  //     // console.log(configData.data.contactPersons
  //     //   .filter( person => person[this.selectedService.label] )
  //     //   .filter( person => person[this.selectedDistrict] ));
  //   });
  // }
}
